import {
    CodebaseTableData
} from "../../models/tables";
import { Table, getFindingValueForSorting } from "../utils";

// Renamed for UI consistency, but still operates on ProjectTableData for backward compatibility
export class CodebaseTable extends Table {
  markAllChecked: boolean = false;

  constructor(data: any) {
    data = data.map((item: any) => {
      return { ...item, checked: false };
    });
    super(data)
  }

  sort(col: string) {
    if (this.sortCol === col) this.sortAsc = !this.sortAsc;
    else this.sortAsc = false;
    this.sortCol = col;
    this.tableData.sort((a: CodebaseTableData, b: CodebaseTableData) => {
      if (col === "findings") {
        if (getFindingValueForSorting(a.findings) < getFindingValueForSorting(b.findings))
          return this.sortAsc ? 1 : -1;
        if (getFindingValueForSorting(a.findings) > getFindingValueForSorting(b.findings))
          return this.sortAsc ? -1 : 1;
      }
      if (
        a[this.sortCol as keyof CodebaseTableData] <
        b[this.sortCol as keyof CodebaseTableData]
      )
        return this.sortAsc ? 1 : -1;
      if (
        a[this.sortCol as keyof CodebaseTableData] >
        b[this.sortCol as keyof CodebaseTableData]
      )
        return this.sortAsc ? -1 : 1;
      return 0;
    });
  }

  toggleAllChecked(event: Event) {
    const checkboxElement = event.target as HTMLInputElement;
    this.tableData.forEach((item: any) => {
      item.checked = checkboxElement.checked;
    });
  }

  onChangeItemChecked(
    event: Event,
    tableItemsData: (CodebaseTableData & { checked: boolean })[]
  ) {
    const checkboxElement = event.target as HTMLInputElement;
    const isAllChecked = !tableItemsData.find((item) => !item.checked);

    if (!checkboxElement.checked) {
      this.markAllChecked = false;
    } else if (isAllChecked) {
      this.markAllChecked = isAllChecked;
    }
  }
}

// Keep ProjectTable for backward compatibility
export class ProjectTable extends CodebaseTable {}
